'use strict';

var _interopRequireWildcard = require('@babel/runtime/helpers/interopRequireWildcard');

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');

Object.defineProperty(exports, '__esModule', {
    value: true,
});
exports['default'] = void 0;

var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'));

var _slicedToArray2 = _interopRequireDefault(require('@babel/runtime/helpers/slicedToArray'));

var _react = _interopRequireWildcard(require('react'));

var _lodash = _interopRequireDefault(require('lodash'));

var _reactComponents = require('../../../../react-components');

var _Switch = _interopRequireDefault(require('../../components/Switch'));

var _components = require('../../components');

var _components2 = require('./components');

var _helpers = require('./helpers');

var _helpers2 = require('../../helpers');

var _styles = _interopRequireDefault(require('./styles'));

var Root = _styles['default'].Root,
    Row = _styles['default'].Row,
    ItemsContainer = _styles['default'].ItemsContainer,
    Column = _styles['default'].Column;
var isBrowser = typeof window !== 'undefined' && window.env;

var SearchResults = function SearchResults(props) {
    var term = props.term,
        zip = props.zip,
        config = props.config,
        env = props.env,
        onBackClick = props.onBackClick,
        mobile = props.mobile;

    var _useState = (0, _react.useState)(false),
        _useState2 = (0, _slicedToArray2['default'])(_useState, 2),
        loaded = _useState2[0],
        setLoaded = _useState2[1];

    var _useState3 = (0, _react.useState)(4),
        _useState4 = (0, _slicedToArray2['default'])(_useState3, 2),
        maxItems = _useState4[0],
        _setMaxItems = _useState4[1];

    var _useState5 = (0, _react.useState)({
            term: term,
            zip: zip,
            subfilter: {},
        }),
        _useState6 = (0, _slicedToArray2['default'])(_useState5, 2),
        query = _useState6[0],
        setQuery = _useState6[1];

    var _useState7 = (0, _react.useState)({
            supplier: null,
            locations: null,
            location: null,
        }),
        _useState8 = (0, _slicedToArray2['default'])(_useState7, 2),
        supplierDetails = _useState8[0],
        setSupplierDetails = _useState8[1];

    var _useState9 = (0, _react.useState)(null),
        _useState10 = (0, _slicedToArray2['default'])(_useState9, 2),
        newLocation = _useState10[0],
        setNewLocation = _useState10[1];

    var _useState11 = (0, _react.useState)(true),
        _useState12 = (0, _slicedToArray2['default'])(_useState11, 2),
        isAvailable = _useState12[0],
        setIsAvailable = _useState12[1];

    var _useState13 = (0, _react.useState)(false),
        _useState14 = (0, _slicedToArray2['default'])(_useState13, 2),
        locationToggle = _useState14[0],
        setLocationToggle = _useState14[1];

    var _useState15 = (0, _react.useState)(false),
        _useState16 = (0, _slicedToArray2['default'])(_useState15, 2),
        itemToggle = _useState16[0],
        setItemToggle = _useState16[1];

    var _useState17 = (0, _react.useState)(null),
        _useState18 = (0, _slicedToArray2['default'])(_useState17, 2),
        curItem = _useState18[0],
        setCurItem = _useState18[1];

    var _useState19 = (0, _react.useState)(false),
        _useState20 = (0, _slicedToArray2['default'])(_useState19, 2),
        viewZipInput = _useState20[0],
        setViewZipInput = _useState20[1];

    var _useState21 = (0, _react.useState)(''),
        _useState22 = (0, _slicedToArray2['default'])(_useState21, 2),
        searchTerm = _useState22[0],
        setSearchTerm = _useState22[1];

    var _useState23 = (0, _react.useState)(false),
        _useState24 = (0, _slicedToArray2['default'])(_useState23, 2),
        locationLoader = _useState24[0],
        setLocationLoader = _useState24[1];

    var _useState25 = (0, _react.useState)(null),
        _useState26 = (0, _slicedToArray2['default'])(_useState25, 2),
        location = _useState26[0],
        setLocation = _useState26[1];

    var _useState27 = (0, _react.useState)(null),
        _useState28 = (0, _slicedToArray2['default'])(_useState27, 2),
        allItems = _useState28[0],
        setAllItems = _useState28[1];

    var _useState29 = (0, _react.useState)(_helpers.priceConfig.options[0]),
        _useState30 = (0, _slicedToArray2['default'])(_useState29, 2),
        priceFilter = _useState30[0],
        setPriceFilter = _useState30[1];

    var _useState31 = (0, _react.useState)({}),
        _useState32 = (0, _slicedToArray2['default'])(_useState31, 2),
        curCat = _useState32[0],
        setCurCat = _useState32[1];

    var clearFilters =
        (searchTerm && searchTerm !== 'clear') ||
        (query.subfilter && query.subfilter.queries) ||
        _lodash['default'].filter(query.subFilters, undefined).length -
            _lodash['default'].filter(curCat.subFilters, 'required').length ===
            (!curCat.multiSelect
                ? _lodash['default'].filter(curCat.subFilters, function(sub) {
                      return !sub.required;
                  }).length
                : 1) ||
        (priceFilter && priceFilter.id !== 1);
    (0, _react.useEffect)(function() {
        setQuery({
            term: term,
            zip: zip,
        });
        setLoaded(true);
        if (isBrowser)
            window.onresize = function(e) {
                return (0, _helpers.handleResize)(e, {
                    setMaxItems: function setMaxItems() {
                        var itemsLength = (0, _helpers2.windowBreakPoints)();

                        _setMaxItems(itemsLength);

                        if (itemsLength === 1) {
                            // setMobile(true);
                        } else {
                            // setMobile(false);
                        }
                    },
                });
            };
        var itemsLength = (0, _helpers2.windowBreakPoints)();

        _setMaxItems(itemsLength); // if (windowBreakPoints() === 1) setMobile(true);
    }, []);
    (0, _react.useEffect)(
        function() {
            if (loaded) setLocationToggle(!locationToggle);
        },
        [supplierDetails],
    );
    (0, _react.useEffect)(
        function() {
            if (loaded) setItemToggle(true);
        },
        [curItem],
    );
    (0, _react.useEffect)(
        function() {
            setViewZipInput(false);
        },
        [query.zip],
    );
    (0, _react.useEffect)(
        function() {
            if (viewZipInput)
                document.getElementsByClassName('location-input')[0].addEventListener('keyup', function(e) {
                    return (0, _helpers.handleLocationInput)(e, {
                        setQuery: setQuery,
                        query: query,
                        location: location,
                    });
                });
        },
        [viewZipInput],
    );
    (0, _react.useEffect)(
        function() {
            config.categories.map(function(category) {
                if (query.term.replace('%20', ' ').includes(category.name)) {
                    setCurCat(category);
                }
            });
        },
        [query],
    );
    return /*#__PURE__*/ _react['default'].createElement(
        _react.Fragment,
        null,
        /*#__PURE__*/ _react['default'].createElement(
            Root,
            {
                mobile: mobile,
            },
            /*#__PURE__*/ _react['default'].createElement(
                Column,
                {
                    margin: !mobile && '3.5rem 1rem',
                },
                /*#__PURE__*/ _react['default'].createElement(
                    Row,
                    {
                        className: 'filters-container',
                        'data-aurora-automation': 'store-quick-categories-container',
                    },
                    config.categories.map(function(choice, i) {
                        if (query.term.replace('%20', ' ').includes(choice.name))
                            return /*#__PURE__*/ _react['default'].createElement(
                                'div',
                                {
                                    className: 'active-category',
                                    key: i,
                                },
                                /*#__PURE__*/ _react['default'].createElement('img', {
                                    alt: 'category-image',
                                    src: choice.imageUrl,
                                }),
                                /*#__PURE__*/ _react['default'].createElement(
                                    'div',
                                    {
                                        className: 'name-title-container',
                                    },
                                    /*#__PURE__*/ _react['default'].createElement('h1', null, choice.name),
                                    /*#__PURE__*/ _react['default'].createElement(
                                        'p',
                                        {
                                            onClick: function onClick() {
                                                return (0, _helpers.handleBackClick)(props);
                                            },
                                        },
                                        config.title,
                                    ),
                                ),
                            );
                    }),
                    config.categories.map(function(choice, i) {
                        if (!query.term.replace('%20', ' ').includes(choice.name))
                            return /*#__PURE__*/ _react['default'].createElement(
                                'div',
                                {
                                    key: i,
                                    className: 'filter ',
                                    'data-aurora-automation': 'store-quick-category',
                                    onClick: function onClick(e) {
                                        return (0, _helpers.handleFilterClick)(e, {
                                            choice: choice.name,
                                            query: query,
                                            setQuery: setQuery,
                                            setSearchTerm: setSearchTerm,
                                            curCat: curCat,
                                        });
                                    },
                                },
                                /*#__PURE__*/ _react['default'].createElement('img', {
                                    alt: 'category-image',
                                    src: choice.imageUrl,
                                }),
                                /*#__PURE__*/ _react['default'].createElement('p', null, choice.name),
                            );
                    }),
                ),
                /*#__PURE__*/ _react['default'].createElement(
                    Row,
                    {
                        className: 'filter-features-row',
                        'data-aurora-automation': 'store-filters-container',
                    },
                    /*#__PURE__*/ _react['default'].createElement(
                        'div',
                        {
                            className: 'availability-container',
                            'data-aurora-automation': 'store-availability-container',
                        },
                        /*#__PURE__*/ _react['default'].createElement(_Switch['default'], {
                            className: 'availability-switch',
                            'data-aurora-automation': 'store-availability-switch',
                            size: 'medium',
                            setEnabled: true,
                            onClick: function onClick(value) {
                                return setIsAvailable(value);
                            },
                        }),
                        /*#__PURE__*/ _react['default'].createElement(
                            'div',
                            {
                                className: 'zip-container',
                            },
                            /*#__PURE__*/ _react['default'].createElement('h4', null, 'Show only available'),
                        ),
                    ),
                    mobile &&
                        viewZipInput &&
                        /*#__PURE__*/ _react['default'].createElement(_reactComponents.Input, {
                            optional: true,
                            className: 'location-input',
                            'data-aurora-automation': 'store-location-input',
                            placeholder: 'ZIP Code',
                            iconRight: locationLoader ? 'fad fa-spinner' : 'fas fa-map-marker-alt',
                            onIconRightClick: function onIconRightClick(e) {
                                return (0, _helpers.locationClick)(e, {
                                    setQuery: setQuery,
                                    query: query,
                                    setLocationLoader: setLocationLoader,
                                    config: config,
                                    setLocation: setLocation,
                                    env: env,
                                });
                            },
                            onChange: function onChange(e) {
                                return (0, _helpers.handleLocationChange)(e.target.value, setLocation);
                            },
                            value: location,
                        }),
                    /*#__PURE__*/ _react['default'].createElement(_reactComponents.Search, {
                        className: 'search-filter',
                        width: mobile ? '100%' : '18rem',
                        'data-aurora-automation': 'store-search-filter',
                        placeholder: 'Search within results\u2026',
                        onSubmit: function onSubmit(value) {
                            return setSearchTerm(value);
                        },
                        clearValue: searchTerm === 'clear',
                        value: '',
                    }),
                    /*#__PURE__*/ _react['default'].createElement(_components2.SubFilters, {
                        config: config,
                        query: query,
                        setQuery: setQuery,
                        onPriceChange: function onPriceChange(value) {
                            return setPriceFilter(value);
                        },
                        priceFilter: priceFilter,
                        priceFilterOptions: _helpers.priceConfig.options,
                    }),
                    clearFilters &&
                        /*#__PURE__*/ _react['default'].createElement(
                            'button',
                            {
                                className: 'clear-filters-btn',
                                onClick: function onClick() {
                                    return (0, _helpers.handleClearClick)({
                                        setQuery: setQuery,
                                        query: query,
                                        setSearchTerm: setSearchTerm,
                                        setPriceFilter: setPriceFilter,
                                        priceConfig: _helpers.priceConfig,
                                        curCat: curCat,
                                    });
                                },
                            },
                            'Clear filters',
                        ),
                ),
                /*#__PURE__*/ _react['default'].createElement(
                    Row,
                    {
                        className: 'zip-input-container',
                    },
                    !mobile &&
                        viewZipInput &&
                        /*#__PURE__*/ _react['default'].createElement(_reactComponents.Input, {
                            optional: true,
                            className: 'location-input',
                            'data-aurora-automation': 'store-location-input',
                            placeholder: 'ZIP Code',
                            iconRight: locationLoader ? 'fad fa-spinner' : 'fas fa-map-marker-alt',
                            onIconRightClick: function onIconRightClick(e) {
                                return (0, _helpers.locationClick)(e, {
                                    setQuery: setQuery,
                                    query: query,
                                    setLocationLoader: setLocationLoader,
                                    config: config,
                                    setLocation: setLocation,
                                    env: env,
                                });
                            },
                            onChange: function onChange(e) {
                                return (0, _helpers.handleLocationChange)(e.target.value, setLocation);
                            },
                            value: location,
                        }),
                ),
                /*#__PURE__*/ _react['default'].createElement(
                    ItemsContainer,
                    {
                        mobile: mobile,
                    },
                    /*#__PURE__*/ _react['default'].createElement(_components2.SupplierRows, {
                        suppliers: props.suppliers,
                        isAvailable: isAvailable,
                        query: query,
                        maxItems: maxItems,
                        config: config,
                        searchTerm: searchTerm,
                        setSupplierDetails: setSupplierDetails,
                        newLocation: newLocation,
                        env: env,
                        mobile: mobile,
                        setCurItem: setCurItem,
                        onItemsLoaded: setAllItems,
                        priceFilter: priceFilter,
                    }),
                ),
            ),
        ),
        !mobile &&
            !itemToggle &&
            supplierDetails.supplier &&
            /*#__PURE__*/ _react['default'].createElement(
                _components.LocationModal,
                (0, _defineProperty2['default'])(
                    {
                        supplierDetails: supplierDetails,
                        toggle: locationToggle,
                        setToggle: setLocationToggle,
                        updateLocation: _helpers.updateLocation,
                        setNewLocation: setNewLocation,
                    },
                    'setToggle',
                    setLocationToggle,
                ),
            ),
        mobile &&
            supplierDetails.supplier &&
            /*#__PURE__*/ _react['default'].createElement(_components.LocationSelect, {
                supplierDetails: supplierDetails,
                toggle: locationToggle,
                updateLocation: _helpers.updateLocation,
                setNewLocation: setNewLocation,
                setToggle: setLocationToggle,
                mobile: mobile,
            }),
        !locationToggle &&
            curItem &&
            /*#__PURE__*/ _react['default'].createElement(_components.ItemDetailsModal, {
                item: curItem,
                allItems: allItems,
                supplierDetails: supplierDetails,
                toggle: itemToggle,
                setToggle: setItemToggle,
                mobile: mobile,
                env: env,
                config: config,
                isAvailable: isAvailable,
                searchTerm: searchTerm,
                setCurItem: setCurItem,
            }),
    );
};

var _default = SearchResults;
exports['default'] = _default;
